"use client";

import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  text: string;
} & ComponentProps<"span">;

export const TipBadge = ({ text, ...props }: Props) => (
  <span
    {...props}
    className={twMerge(
      "rounded-3xl bg-yellow-100 px-2 py-0 text-xs font-normal text-yellow-600",
      props.className
    )}
  >
    {text}
  </span>
);
